import { BarChart3 } from 'lucide-react'

interface ChartEmptyStateProps {
  message?: string
}

export function ChartEmptyState({
  message = 'No responses yet',
}: ChartEmptyStateProps) {
  return (
    <div className="flex flex-col items-center justify-center min-h-[250px] text-muted-foreground w-full">
      <BarChart3 className="h-8 w-8 mb-3" />
      <p className="text-sm">{message}</p>
    </div>
  )
}
